<template>
    <div class="table-list">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" summary="정산 리스트" class="settle-top-list">
            <caption style="display: none;">정산 목록</caption>
            
            <colgroup>
                <col width="20%">
                <col width="*%">
                <col width="20%">
                <col width="10%">
                <col width="10%">
                <col width="10%">
            </colgroup>
            <thead>
            <tr>
                <th>일자</th>
                <th>병원/의사</th>
                <th>연락처</th>
                <th>전체</th>
                <th>진료완료</th>
                <th>금액</th>
            </tr>
            </thead>
            <tbody>
                <tr v-for="(settlement, index) in top_settlements" @click="chosen_row(settlement, index)" :key="settlement.date">
                    <!-- <td>{{ settlement.date }}</td> -->
                    <td>{{ settlement.year }}-{{ settlement.month }}</td>
                    <td>{{ settlement.dr_name }}</td>
                    <td>{{ settlement.dr_contact | phone_format }}</td>
                    <td>{{ settlement.total_count }} 건</td>
                    <td>{{ settlement.finished_count }} 건</td>
                    <td>{{ settlement.total_sum_price | price_format }} 원</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    name: 'settle-top-list',
    props: ['top_settlements'],
    data () {
      return {
        chk_chosen: false,
      }
    },
    computed: {
        // ...mapState(['account'])
    },
    methods: {
        chosen_row (settlement, idx) {
            // this.current_note = note;
            this.chk_chosen = true;
            settlement.index = idx;
            this.$emit('onSelectRow', settlement);
        },
    },
    updated() {
        this.$nextTick(function () {
            if(!this.chk_chosen && this.events[0]) this.chosen_row(this.events[0], 0) // 모든 화면이 렌더링된 후 실행합니다.
            //this.chk_chosen = false
        })
    },
    mounted() {
    },
}
</script>

<style scoped>
    .settle-top-list thead {
        width: 100%;
        height: 40px;
        border-bottom: 1px solid #e7e7e9;
    }

    .settle-top-list thead th {
        color: #b8b8b8;
        font: 500 12px/40px 'Noto Sans KR', sans-serif;
    }

    .settle-top-list tbody tr {
        /* height: 70px; */
        height: 40px;
        background-color: #fff;
        cursor: pointer;
        border-bottom: 1px solid #e7e7e9;
    }

    .settle-top-list tbody tr:hover,
    .settle-top-list tbody tr.on {
        background-color: #f5f6fa;
    }

    .settle-top-list tbody td {
        text-align: center;
        vertical-align: middle;
        font: 400 12px 'Noto Sans KR', sans-serif;
    }

    .settle-top-list tbody td .user-name {
        float: left;
        overflow: hidden;
        width: 120px;
        height: 40px;
        line-height: 40px;
        margin-right: 15px;
        padding-left: 10px;
    }

    .settle-top-list tbody td .event-name {
        float: left;
        text-align: left;
    }
</style>